import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import React, { FC } from 'react';
import { OnlineOrderType } from '../../../../domain/models/CommonTypes';
import { useObserver } from 'mobx-react-lite';
import { makeStyles, Typography, Grid } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  selectedOrderType: {
    color: `${theme.palette.primary.main} !important`,
    background: `transparent !important`
  }
}));

interface SelectOrderTypeProps {
  onChange?: (type: OnlineOrderType) => void;
  disabled?: boolean;
  value?: OnlineOrderType;
  acceptedOrderTypes?: OnlineOrderType[];
}

const SelectOrderType: FC<SelectOrderTypeProps> = ({
  acceptedOrderTypes,
  value,
  onChange,
  disabled
}) => {
  const classes = useStyles();
  // Default to all options
  const types = acceptedOrderTypes ?? ['pickup', 'delivery', 'dinein'];
  const handleValueChange = (_e: any, newValue: OnlineOrderType) => {
    if (onChange !== undefined) {
      onChange(newValue);
    }
  };

  return useObserver(() => (
    <Grid>
      <Grid
        container
        direction="column"
        justify="center"
        alignItems="flex-start"
      >
        <Typography variant="caption" color="primary">
          <br />
        </Typography>
        <ToggleButtonGroup
          value={value}
          exclusive
          onChange={handleValueChange}
          aria-label="pickup delivery dine-in"
        >
          {types.map(option => (
            <ToggleButton
              key={option}
              value={option}
              aria-label={`select ${option}`}
              disabled={disabled}
              classes={{
                selected: classes.selectedOrderType
              }}
            >
              {option.toUpperCase()}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Grid>
    </Grid>
  ));
};

export default SelectOrderType;
